import api from 'api';
import storage from "@/cflow/storageService";

class ProteticosService {

    listar(dados, skip) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/proteticos?skip='+skip+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/proteticos?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/proteticos/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/proteticos/' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    excluir(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.delete('/proteticos/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    buscarPorLab(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/proteticos/lab/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new ProteticosService();